import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { YardMapConfigurationRoutingModule } from './yard-map-configuration.routing-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ApplicationClientCommonModule, CommonTranslationModule } from '@sdbn/common';
import { ColorPickerModule } from '@sdbn/tmc-common';
import { MapDetailsComponent } from './component/map-details/map-details.component';
import { StationAssignmentDetailsComponent } from './component/station-assignment-details/station-assignment-details.component';
import { YardMapConfigurationComponent } from './component/yard-map-configuration/yard-map-configuration.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    YardMapConfigurationComponent,
    StationAssignmentDetailsComponent,
    MapDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    YardMapConfigurationRoutingModule,
    ColorPickerModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    MatFormFieldModule,
    MatSelectModule,
    DragDropModule,
    MatInputModule
  ],

})
export class YardMapConfigurationModule { }
